import { useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';

// ResumeGate is the sole continuation executor. It reads the persisted resume
// payload, clears it, and hands off to the correct destination once per auth session.
export default function ResumeGate() {
  const history = useHistory();
  const ranRef = useRef(false);

  useEffect(() => {
    if (ranRef.current) return;
    ranRef.current = true;
    console.log('[ResumeGate] mounted');

    const raw = localStorage.getItem('jg:resume');
    if (!raw) {
      console.log('[ResumeGate] no resume found');
      return;
    }

    let resume;
    try {
      resume = JSON.parse(raw);
    } catch (err) {
      console.warn('[ResumeGate] invalid resume payload, clearing', raw);
      localStorage.removeItem('jg:resume');
      return;
    }

    console.log('[ResumeGate] resume payload parsed', resume);

    // Consume resume exactly once
    localStorage.removeItem('jg:resume');
    console.log('[ResumeGate] resume consumed and cleared');

    if (resume.type === 'localops') {
      console.log('[ResumeGate] routing to /playermap with resumeLocalOps');
      history.replace('/playermap', {
        resumeLocalOps: resume,
      });
    } else {
      console.log('[ResumeGate] unknown resume type, ignoring', resume.type);
    }
  }, [history]);

  return null;
}
